<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'UserDividend'
};
</script>

<style lang="less" scoped></style>
